/**
 * Network Configuration Index
 * Re-exports network configurations for easy importing
 */

import { 
  resolveDefaultNetwork, 
  getDefaultToken as getTokenForNetwork,
  NETWORK_REGISTRY 
} from './registry';

export {
  NETWORK_REGISTRY,
  NETWORK_RESOLUTION_CONFIG,
  getNetworkById,
  getNetworkByChainId,
  getAllNetworks,
  getMainnetNetworks,
  getTestnetNetworks,
  resolveDefaultNetwork,
  getDefaultToken as getTokenForNetwork,
  validateNetwork
} from './registry';

// Import and re-export the main NetworkConfigService
export { default as NetworkConfigService } from '../../services/NetworkConfigService';
export { default as ContractCacheService } from '../../services/ContractCacheService';

// Default exports for backward compatibility
export const DEFAULT_NETWORK = resolveDefaultNetwork();
export const DEFAULT_TOKEN = getTokenForNetwork(DEFAULT_NETWORK.id);
export const SUPPORTED_NETWORKS = NETWORK_REGISTRY;

// Export NETWORKS for backward compatibility with tokens.js
export const NETWORKS = NETWORK_REGISTRY;

// Legacy token configurations for backward compatibility
export const TOKENS_BY_NETWORK = {
  ethereum: NETWORK_REGISTRY.ethereum.tokens,
  sepolia: NETWORK_REGISTRY.sepolia.tokens,
  polygon: NETWORK_REGISTRY.polygon.tokens
};

export const SUPPORTED_TOKENS = {
  USDC: 'USDC',
  USDT: 'USDT'
};

// Export getDefaultNetwork function for backward compatibility
export const getDefaultNetwork = resolveDefaultNetwork;

// Export getDefaultToken function for backward compatibility
export const getDefaultToken = getTokenForNetwork;